function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import VideoComponent from "components/core/video/video-component";
import SignupRightDecoration from "/static/svg/decorators/signup/signup-decoration-right.svg";
import ParagraphComponent from "/components/core/paragraph/paragraph-component";
import EmbeddedFormComponent from "/components/segments/embedded-form/embedded-form-component";
class FormWithTextAndAssetsComponent extends PureComponent {
    renderParagraph() {
        const { paragraph, marginBottomParagraph } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            style: {
                marginBottom: marginBottomParagraph
            },
            children: /*#__PURE__*/ _jsx(ParagraphComponent, _object_spread({}, paragraph))
        });
    }
    renderVideo() {
        const { video } = this.props;
        if (video && video.src) {
            const { formats } = video.src;
            return /*#__PURE__*/ _jsx(VideoComponent, _object_spread_props(_object_spread({}, video, video.src), {
                formats: formats
            }));
        }
    }
    renderForm() {
        const { formToken, width, height, boxShadow, marginLeft, borderRadius, showFormDecorations, columnsMappingFromParams } = this.props;
        const { circle } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "embedded-form-component",
            style: {
                width,
                height,
                boxShadow,
                marginLeft,
                position: "relative",
                borderRadius
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    style: _object_spread({}, circle)
                }),
                /*#__PURE__*/ _jsx(EmbeddedFormComponent, {
                    formToken: formToken,
                    width: width,
                    height: height,
                    columnsMappingFromParams: columnsMappingFromParams
                }),
                showFormDecorations && /*#__PURE__*/ _jsx(SignupRightDecoration, {
                    style: {
                        transform: "rotate(-25deg)",
                        position: "absolute",
                        top: "-20px",
                        left: "92%"
                    }
                }, "right-decoration")
            ]
        });
    }
    render() {
        const { marginTop, marginTopAsset } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "paragaph-and-asset-component",
                style: {
                    marginTop,
                    display: "flex",
                    flexWrap: "wrap",
                    margin: "4px"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            display: "block",
                            marginTop: marginTopAsset,
                            maxWidth: "50%"
                        },
                        children: [
                            this.renderParagraph(),
                            this.renderVideo()
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            display: "flex"
                        },
                        children: this.renderForm()
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
    }
}
export { FormWithTextAndAssetsComponent as default };
FormWithTextAndAssetsComponent.defaultProps = {
    content: {
        topic: {
            text: "Simple and intuitive",
            color: "brand-blue"
        },
        title: "Easy onboarding, fast adoption",
        body: [
            "Getting your team onboard recuires sending an invatation, and that’s it! It’s so visual and easy to use your teammates will get hooked immediatly."
        ],
        bottomLink: {
            href: "/",
            text: "See all features"
        }
    },
    asset: {
        side: "right",
        shadow: false
    }
};
